import { StateReducers } from '../reducers/types/StateReducers'
import { getWindowWidth } from './getWindowWidth'

interface Props {
  state: StateReducers
}

export const getIsMediumScreen = ({ state }: Props): boolean => {
  const windowWidth = getWindowWidth({ state })

  return windowWidth >= 480
}
